import { helper } from "src/utils/helper";

class VwHastaraporDTO {
    id: number = 0;
    organizasyonId?: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    raportiptanimId?: number = null;
    hastaislemId?: number = null;
    raportip?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    kabultarihsaat?: string = helper.datetimeNow();
    raportiptanim?: string = "";
    onayTarih?: string = null;
    onaydr?: string = "";
    islemtanim?: string = "";
    islemdurum?: number = null;
    doktorId?: number = null;
    servisId?: number = null;
    odemeyontem?: number = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    islemtanimId?: number = null;
    ucretTarifetanimId?: number = null;
    diskayit?: string = "";
    hastaAdiSoyadi?: string = "";
    raporStr?: string = "";
}
export default VwHastaraporDTO;